package com.schoolconnect.app.feature.timetable

import com.schoolconnect.app.feature.common.PaginationPolicy
import com.schoolconnect.app.datasource.network.request.TimetableCombinedCreateRequest
import com.schoolconnect.app.datasource.network.response.TimetableViewResponse

data class TimetableClassSectionOption(val id: String, val className: String, val sectionName: String)

data class TimeTableRow(
    val id: String,
    val headerId: String? = null,
    val classSectionId: String,
    val classSection: String,
    val lastUpdated: String,
    val lastUpdatedBy: String,
    val status: String
)

object TimetableStatusValues {
    const val PUBLISHED = "Published"
    const val CHANGES_PENDING = "Changes Pending"
    const val NOT_PUBLISHED = "Not Published"
    const val BLANK = "Blank"
}

data class TimeTableUiState(
    val searchQuery: String = "",
    val classFilter: String = "",
    val statusFilter: String = "",
    val pageIndex: Int = 0,
    val pageSize: Int = PaginationPolicy.DEFAULT_PAGE_SIZE,
    val totalCount: Int = 0,
    val isLoading: Boolean = false,
    val errorMessage: String = "",
    val selectedRowId: String? = null,
    val sortBy: String = "",
    val sortAscending: Boolean = true,
    val rows: List<TimeTableRow> = emptyList(),
    val classSections: List<TimetableClassSectionOption> = emptyList(),
    val timetableSubjects: List<String> = emptyList(),
    val areTimetableSubjectsLoading: Boolean = false,
    val timetableSubjectsError: String = "",
    val timetableSubjectsClassSectionId: String = "",
    val academicYearStartDate: String = "",
    val academicYearEndDate: String = "",
    val isAcademicYearLoading: Boolean = false,
    val academicYearError: String = "",
    val editorTimetableClassSectionId: String = "",
    val editorTimetableHeaderId: String? = null,
    val editorTimetable: TimetableViewResponse? = null,
    val isEditorTimetableLoading: Boolean = false,
    val editorTimetableError: String = "",
    val editorSaveError: String = "",
    val viewDetails: TimetableViewResponse? = null,
    val isViewLoading: Boolean = false,
    val viewErrorMessage: String = ""
)

sealed interface TimeTableUiEvent {
    data class TimetableSaved(
        val headerId: String?,
        val request: TimetableCombinedCreateRequest,
        val onSuccess: () -> Unit = {}
    ) : TimeTableUiEvent
    data class ViewRequested(val row: TimeTableRow) : TimeTableUiEvent
    data class ClassSectionSelected(val classSectionId: String) : TimeTableUiEvent
    data object ViewDismissed : TimeTableUiEvent
    data class SearchChanged(val value: String) : TimeTableUiEvent
    data class ClassFilterChanged(val value: String) : TimeTableUiEvent
    data class StatusFilterChanged(val value: String) : TimeTableUiEvent
    data class PageChanged(val value: Int) : TimeTableUiEvent
    data class PageSizeChanged(val value: Int) : TimeTableUiEvent
    data class SortChanged(val value: String) : TimeTableUiEvent
    data class RowActionsToggled(val id: String) : TimeTableUiEvent
    data object FiltersCleared : TimeTableUiEvent
}
